import { ANPREvent } from 'domain/anpr-event'

export interface VehicleTypeBreakdownEntry {
  type: string
  label: string
  count: number
}

const KNOWN_TYPE_LABELS: Record<string, string> = {
  cars: 'Carros',
  bikes: 'Motos',
  trucks: 'Caminhões',
  buses: 'Ônibus',
  people: 'Pessoas',
}

/** Contagem por tipo de veículo sobre o conjunto de eventos já filtrado —
 *  responde "desses N eventos, quantos são carros/motos/...". Só inclui
 *  categorias com pelo menos 1 ocorrência, maior contagem primeiro. */
export const buildVehicleTypeBreakdown = (
  events: ANPREvent[]
): VehicleTypeBreakdownEntry[] => {
  const counts = new Map<string, number>()

  events.forEach((event) => {
    const type = event.vehicleType || 'unknown'
    counts.set(type, (counts.get(type) ?? 0) + 1)
  })

  return Array.from(counts.entries())
    .map(([type, count]) => ({
      type,
      label: KNOWN_TYPE_LABELS[type] ?? 'Outros',
      count,
    }))
    .sort((a, b) => b.count - a.count)
}
